<template>
  <div class="container">
    <div class="container">
      <!-- <div class="row pb-4">
        <h3 class="text-center">{{ $t("sistemi_prokurorial.care.title") }}</h3>
      </div> -->
      <div class="row g-4">
        <div class="col-12 col-md-6 d-flex" v-for="item in data" :key="item.id">
          <contactTemplate :data="item" class="w-100" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contactTemplate from '../share/ContactTemplate.vue'

export default {
  components: { contactTemplate },

  data() {
    return {
      subdomain: '',
      data: []
    }
  },

  mounted() {
    this.getSubdomain();
    this.data = this.getDataForSubdomain(this.subdomain);
  },

  methods: {
    getSubdomain() {
      const host = window.location.hostname; // p.sh. "kpk.localhost"
        this.subdomain = ''; // Default subdomain
        if (host.includes('.')) {
            this.subdomain = host.split('.')[0];
        }
    },

    getDataForSubdomain(sub) {
      const allData = {
        localhost: [
          {
            id: 0,
            icon: "fa-phone-volume",
            title: this.$te("sistemi_prokurorial.care.topcard.title") ? this.$t("sistemi_prokurorial.care.topcard.title") : null,
            fullName:this.$te("sistemi_prokurorial.care.topcard.fullName") ? this.$t("sistemi_prokurorial.care.topcard.fullName") : null,
            email:this.$te("sistemi_prokurorial.care.topcard.email") ? this.$t("sistemi_prokurorial.care.topcard.email") : null,
            tel1:this.$te("sistemi_prokurorial.care.topcard.tel1") ? this.$t("sistemi_prokurorial.care.topcard.tel1") : null,
            address:this.$te("sistemi_prokurorial.care.topcard.address") ? this.$t("sistemi_prokurorial.care.topcard.address") : null
          },
          {
            id: 1,
            icon: "fa-phone-volume",
            title: this.$te("sistemi_prokurorial.care.cardright.title") ? this.$te("sistemi_prokurorial.care.cardright.title") : null ,
            description: this.$te("sistemi_prokurorial.care.cardright.description") ? this.$t("sistemi_prokurorial.care.cardright.description") : null,
            button: "/zmnv-contact",
            buttonLabel: this.$te("sistemi_prokurorial.care.cardright.button") ? this.$t("sistemi_prokurorial.care.cardright.button") : null,
            tel: "080011112"
          },
           {
            id: 2,
            icon: "fa-phone-volume",
            title: this.$te("sistemi_prokurorial.care.cardright.title") ? this.$te("sistemi_prokurorial.care.cardright.title") : null ,
            description: this.$te("sistemi_prokurorial.care.cardright.description") ? this.$t("sistemi_prokurorial.care.cardright.description") : null,
            button: "/zmnv-contact",
            buttonLabel: this.$te("sistemi_prokurorial.care.cardright.button") ? this.$t("sistemi_prokurorial.care.cardright.button") : null,
            tel: "080011112"
          }
        ],
        default: [
            {
            id: 0,
            icon: "fa-phone-volume",
            title: this.$te("sistemi_prokurorial.care.topcard.title") ? this.$t("sistemi_prokurorial.care.topcard.title") : null,
            fullName:this.$te("sistemi_prokurorial.care.topcard.fullName") ? this.$t("sistemi_prokurorial.care.topcard.fullName") : null,
            email:this.$te("sistemi_prokurorial.care.topcard.email") ? this.$t("sistemi_prokurorial.care.topcard.email") : null,
            tel1:this.$te("sistemi_prokurorial.care.topcard.tel1") ? this.$t("sistemi_prokurorial.care.topcard.tel1") : null,
            address:this.$te("sistemi_prokurorial.care.topcard.address") ? this.$t("sistemi_prokurorial.care.topcard.address") : null
          },
          {
            id: 1,
            icon: "fa-phone-volume",
            title: this.$te("sistemi_prokurorial.care.cardright.title") ? this.$t("sistemi_prokurorial.care.cardright.title") : null,
            description: this.$te("sistemi_prokurorial.care.cardright.description") ? this.$t("sistemi_prokurorial.care.cardright.description") : null,
            button: "/zmnv-contact",
            buttonLabel: this.$te("sistemi_prokurorial.care.cardright.button") ? this.$t("sistemi_prokurorial.care.cardright.button") : null,
            tel: "080011112"
          },
           {
            id: 2,
            icon: "fa-phone-volume",
            title: this.$te("sistemi_prokurorial.care.cardright.title") ? this.$t("sistemi_prokurorial.care.cardright.title") : null,
            description: this.$te("sistemi_prokurorial.care.cardright.description") ? this.$t("sistemi_prokurorial.care.cardright.description") : null,
            button: "/zmnv-contact",
            buttonLabel: this.$te("sistemi_prokurorial.care.cardright.button") ? this.$t("sistemi_prokurorial.care.cardright.button") : null,
            tel: "080011112"
          }
        ],
        kpk: [
          {
            id: 0,
            icon: "fa-phone-volume",
            title: this.$te("keshilli_prokurorial.care.cardleft.title") ? this.$t("keshilli_prokurorial.care.cardleft.title") : null,
            fullName:this.$te("keshilli_prokurorial.care.cardleft.fullName") ? this.$t("keshilli_prokurorial.care.cardleft.fullName") : null,
            email:this.$te("keshilli_prokurorial.care.cardleft.email") ? this.$t("keshilli_prokurorial.care.cardleft.email") : null,
            tel1:this.$te("keshilli_prokurorial.care.cardleft.tel1") ? this.$t("keshilli_prokurorial.care.cardleft.tel1") : null,
            address:this.$te("keshilli_prokurorial.care.cardleft.address") ? this.$t("keshilli_prokurorial.care.cardleft.address") : null,
            button1:this.$te("keshilli_prokurorial.care.cardleft.button1") ? this.$t("keshilli_prokurorial.care.cardleft.button1") : null,
            button2:this.$te("keshilli_prokurorial.care.cardleft.button2") ? this.$t("keshilli_prokurorial.care.cardleft.button2") : null,
          },
           {
            id: 1,
            icon: "fa-phone-volume",
            title: this.$te("keshilli_prokurorial.care.cardright.title") ? this.$t("keshilli_prokurorial.care.cardright.title") : null,
            fullName:this.$te("keshilli_prokurorial.care.cardright.fullName") ? this.$t("keshilli_prokurorial.care.cardright.fullName") : null,
            email:this.$te("keshilli_prokurorial.care.cardright.email") ? this.$t("keshilli_prokurorial.care.cardright.email") : null,
            tel1:this.$te("keshilli_prokurorial.care.cardright.tel1") ? this.$t("keshilli_prokurorial.care.cardright.tel1") : null,
            tel2:this.$te("keshilli_prokurorial.care.cardright.tel2") ? this.$t("keshilli_prokurorial.care.cardright.tel2") : null,
            address:this.$te("keshilli_prokurorial.care.cardright.address") ? this.$t("keshilli_prokurorial.care.cardright.address") : null,
            button1:this.$te("sistemi_prokurorial.care.cardleft.button1") ? this.$t("sistemi_prokurorial.care.cardleft.button1") : null,
            button2:this.$te("keshilli_prokurorial.care.cardright.button2")  ? this.$t("keshilli_prokurorial.care.cardright.button2") : null ,
          },
          {
            id: 1,
            icon: "fa-phone-volume",
            title: this.$te("keshilli_prokurorial.care.cardthree.title") ? this.$t("keshilli_prokurorial.care.cardthree.title") : null,
            fullName:this.$te("keshilli_prokurorial.care.cardthree.fullName") ? this.$t("keshilli_prokurorial.care.cardthree.fullName") : null,
            email:this.$te("keshilli_prokurorial.care.cardthree.email") ? this.$t("keshilli_prokurorial.care.cardthree.email") : null,
            tel1:this.$te("keshilli_prokurorial.care.cardthree.tel1") ? this.$t("keshilli_prokurorial.care.cardthree.tel1") : null,
            tel2:this.$te("keshilli_prokurorial.care.cardthree.tel2") ? this.$t("keshilli_prokurorial.care.cardthree.tel2") : null,
            address:this.$te("keshilli_prokurorial.care.cardthree.address") ? this.$t("keshilli_prokurorial.care.cardthree.address") : null,
            button1:this.$te("sistemi_prokurorial.care.carthree.button1") ? this.$t("sistemi_prokurorial.care.carthree.button1") : null,
            button2:this.$te("keshilli_prokurorial.care.cardthree.button2")  ? this.$t("keshilli_prokurorial.care.cardthree.button2") : null ,
          }
        ],
        pa: [
          {
              id: 0,
              icon: "fa-phone-volume",
              title: this.$te("menus.pa.care.cardleft.title") ? this.$t("menus.pa.care.cardleft.title") : null,
              fullName:this.$te("menus.pa.care.cardleft.fullName") ? this.$t("menus.pa.care.cardleft.fullName") : null,
              position:this.$te("menus.pa.care.cardleft.position") ? this.$t("menus.pa.care.cardleft.position") : null,
              email:this.$te("menus.pa.care.cardleft.email") ? this.$t("menus.pa.care.cardleft.email") : null,
              tel1:this.$te("menus.pa.care.cardleft.tel1") ? this.$t("menus.pa.care.cardleft.tel1") : null,
              address:this.$te("menus.pa.care.cardleft.address") ? this.$t("menus.pa.care.cardleft.address") : null,
              button1:this.$te("menus.pa.carecardleft.button1") ? this.$t("menus.pa.carecardleft.button1") : null,
              button2:this.$te("menus.pa.care.cardleft.button2") ? this.$t("menus.pa.care.cardleft.button2") : null ,
            },
            {
              id: 1,
              icon: "fa-phone-volume",
              title: this.$te("menus.pa.care.cardright.title") ? this.$t("menus.pa.care.cardright.title") : null,
              fullName:this.$te("menus.pa.care.cardright.fullName") ? this.$t("menus.pa.care.cardright.fullName") : null,
              position:this.$te("menus.pa.care.cardright.position") ? this.$t("menus.pa.care.cardright.position") : null,
              email:this.$te("menus.pa.care.cardright.email") ? this.$t("menus.pa.care.cardright.email") : null,
              tel1:this.$te("menus.pa.care.cardright.tel1") ? this.$t("menus.pa.care.cardright.tel1") : null,
              address:this.$te("menus.pa.care.cardright.address") ? this.$t("menus.pa.care.cardright.address") : null,
              button1:this.$te("menus.pa.care.cardleft.button1") ? this.$t("menus.pa.care.cardleft.button1") : null,
              button2:this.$te("menus.pa.care.cardright.button2") ? this.$t("menus.pa.care.cardright.button2") : null ,
            },
             {
              id: 2,
               icon: "fa-phone-volume",
             title: this.$te("menus.pa.care.cardthree.title") ? this.$t("menus.pa.care.cardthree.title") : null,
              fullName:this.$te("menus.pa.care.cardthree.fullName") ? this.$t("menus.pa.care.cardthree.fullName") : null,
              position:this.$te("menus.pa.care.cardthree.position") ? this.$t("menus.pa.care.cardthree.position") : null,
              email:this.$te("menus.pa.care.cardthree.email") ? this.$t("menus.pa.care.cardthree.email") : null,
              tel1:this.$te("menus.pa.care.cardthree.tel1") ? this.$t("menus.pa.care.cardthree.tel1") : null,
              address:this.$te("menus.pa.care.cardthree.address") ? this.$t("menus.pa.care.cardthree.address") : null,
              button1:this.$te("menus.pa.care.cardthree.button1") ? this.$t("menus.pa.care.cardthree.button1") : null,
              button2:this.$te("menus.pa.care.cardthree.button2") ? this.$t("menus.pa.care.cardthree.button2") : null ,
            },
            {
              id: 3,
              icon: "fa-phone-volume",
              title: this.$te("menus.pa.care.cardfour.title") ? this.$t("menus.pa.care.cardfour.title") : null,
              fullName:this.$te("menus.pa.care.cardfour.fullName") ? this.$t("menus.pa.care.cardfour.fullName") : null,
              position:this.$te("menus.pa.care.cardfour.position") ? this.$t("menus.pa.care.cardfour.position") : null,
              email:this.$te("menus.pa.care.cardfour.email") ? this.$t("menus.pa.care.cardfour.email") : null,
              tel1:this.$te("menus.pa.care.cardfour.tel1") ? this.$t("menus.pa.care.cardfour.tel1") : null,
              address:this.$te("menus.pa.care.cardfour.address") ? this.$t("menus.pa.care.cardfour.address") : null,
              button1:this.$te("menus.pa.care.cardfour.button1") ? this.$t("menus.pa.care.cardfour.button1") : null,
              button2:this.$te("menus.pa.care.cardfour.button2") ? this.$t("menus.pa.care.cardfour.button2") : null ,
            }
        ],
        ps: [
            {
              id: 0,
              icon: "fa-phone-volume",
              title: this.$te("menus.ps.care.cardleft.title") ? this.$t("menus.ps.care.cardleft.title") : null,
              fullName:this.$te("menus.ps.care.cardleft.fullName") ? this.$t("menus.ps.care.cardleft.fullName") : null,
              position:this.$te("menus.ps.care.cardleft.position") ? this.$t("menus.ps.care.cardleft.position") : null,
              email:this.$te("menus.ps.care.cardleft.email") ? this.$t("menus.ps.care.cardleft.email") : null,
              tel1:this.$te("menus.ps.care.cardleft.tel1") ? this.$t("menus.ps.care.cardleft.tel1") : null,
              address:this.$te("menus.ps.care.cardleft.address") ? this.$t("menus.ps.care.cardleft.address") : null,
              button1:this.$te("menus.ps.carecardleft.button1") ? this.$t("menus.ps.carecardleft.button1") : null,
              button2:this.$te("menus.ps.care.cardleft.button2") ? this.$t("menus.ps.care.cardleft.button2") : null ,
            },
            {
              id: 1,
              icon: "fa-phone-volume",
              title: this.$te("menus.ps.care.cardright.title") ? this.$t("menus.ps.care.cardright.title") : null,
              fullName:this.$te("menus.ps.care.cardright.fullName") ? this.$t("menus.ps.care.cardright.fullName") : null,
              position:this.$te("menus.ps.care.cardright.position") ? this.$t("menus.ps.care.cardright.position") : null,
              email:this.$te("menus.ps.care.cardright.email") ? this.$t("menus.ps.care.cardright.email") : null,
              tel1:this.$te("menus.ps.care.cardright.tel1") ? this.$t("menus.ps.care.cardright.tel1") : null,
              address:this.$t("menus.ps.care.cardright.address") ? this.$t("menus.ps.care.cardright.address") : null,
              button1:this.$te("menus.ps.care.cardleft.button1") ? this.$t("menus.ps.care.cardleft.button1") : null,
              button2:this.$te("menus.ps.care.cardright.button2") ? this.$t("menus.ps.care.cardright.button2") : null ,
            },
            {
              id: 2,
              icon: "fa-phone-volume",
              title: this.$te("menus.ps.care.cardthree.title") ? this.$t("menus.ps.care.cardthree.title") : null,
              fullName:this.$te("menus.ps.care.cardthree.fullName") ? this.$t("menus.ps.care.cardthree.fullName") : null,
              position:this.$te("menus.ps.care.cardthree.position") ? this.$t("menus.ps.care.cardthree.position") : null,
              email:this.$te("menus.ps.care.cardthree.email") ? this.$t("menus.ps.care.cardthree.email") : null,
              tel1:this.$te("menus.ps.care.cardthree.tel1") ? this.$t("menus.ps.care.cardthree.tel1") : null,
              address:this.$te("menus.ps.care.cardthree.address") ? this.$t("menus.ps.care.cardthree.address") : null,
              button1:this.$te("menus.ps.care.cadthree.button1") ? this.$t("menus.ps.care.cdthreet.button1") : null,
              button2:this.$te("menus.ps.care.cardthree.button2") ? this.$t("menus.ps.care.cardthree.button2") : null ,
            },
            {
              id: 3,
              icon: "fa-phone-volume",
              title: this.$te("menus.ps.care.cardfour.title") ? this.$t("menus.ps.care.cardfour.title") : null,
              fullName:this.$te("menus.ps.care.cardfour.fullName") ? this.$t("menus.ps.care.cardfour.fullName") : null,
              position:this.$te("menus.ps.care.cardfour.position") ? this.$t("menus.ps.care.cardfour.position") : null,
              email:this.$te("menus.ps.care.cardfour.email") ? this.$t("menus.ps.care.cardfour.email") : null,
              tel1:this.$te("menus.ps.care.cardfour.tel1") ? this.$t("menus.ps.care.cardfour.tel1") : null,
              address:this.$te("menus.ps.care.cardfour.address") ? this.$t("menus.ps.care.cardfour.address") : null,
              button1:this.$te("menus.ps.care.cadfour.button1") ? this.$t("menus.ps.care.cdtfour.button1") : null,
              button2:this.$te("menus.ps.care.cardfour.button2") ? this.$t("menus.ps.care.cardfour.button2") : null ,
            }
        ],
         zkpsh: [
            {
              id: 0,
              icon: "fa-phone-volume",
              title: this.$te("menus.zkpsh.care.cardleft.title") ? this.$t("menus.zkpsh.care.cardleft.title") : null,
              description: this.$te("menus.zkpsh.care.cardleft.description") ? this.$t("menus.zkpsh.care.cardleft.description") : null,
              button: "/kujdestarit-contact",
              buttonLabel: this.$te("menus.zkpsh.care.cardleft.button") ? this.$t("menus.zkpsh.care.cardleft.button") : null,
              tel: ""
            },
            {
              id: 1,
              icon: "fa-phone-volume",
              title: this.$te("sistemi_prokurorial.care.cardright.title") ? this.$t("sistemi_prokurorial.care.cardright.title") : null,
              description: this.$te("sistemi_prokurorial.care.cardright.description") ? this.$t("sistemi_prokurorial.care.cardright.description") : null,
              button: "/zmnv-contact",
              buttonLabel: this.$te("sistemi_prokurorial.care.cardright.button") ? this.$t("sistemi_prokurorial.care.cardright.button") : null,
              tel: "080011112"
            },
            {
              id: 2,
              icon: "fa-phone-volume",
              title: this.$te("menus.zkpsh.care.cardfive.title") ? this.$t("menus.zkpsh.care.cardfive.title") : null,
              fullName:this.$te("menus.zkpsh.care.cardfive.fullName") ? this.$t("menus.zkpsh.care.cardfive.fullName") : null,
              position:this.$te("menus.zkpsh.care.cardfive.position") ? this.$t("menus.zkpsh.care.cardfive.position") : null,
              email:this.$te("menus.zkpsh.care.cardfive.email") ? this.$t("menus.zkpsh.care.cardfive.email") : null,
              tel1:this.$te("menus.zkpsh.care.cardfive.tel1") ? this.$t("menus.zkpsh.care.cardfive.tel1") : null,
              address:this.$te("menus.zkpsh.care.cardfive.address") ? this.$t("menus.zkpsh.care.cardfive.address") : null
            },
            {
              id: 3,
              icon: "fa-phone-volume",
              title: this.$te("menus.zkpsh.care.cardfour.title") ? this.$t("menus.zkpsh.care.cardfour.title") : null,
              fullName:this.$te("menus.zkpsh.care.cardfour.fullName") ? this.$t("menus.zkpsh.care.cardfour.fullName") : null,
              position:this.$te("menus.zkpsh.care.cardfour.position") ? this.$t("menus.zkpsh.care.cardfour.position") : null,
              email:this.$te("menus.zkpsh.care.cardfour.email") ? this.$t("menus.zkpsh.care.cardfour.email") : null,
              tel1:this.$te("menus.zkpsh.care.cardfour.tel1") ? this.$t("menus.zkpsh.care.cardfour.tel1") : null,
              address:this.$te("menus.zkpsh.care.cardfour.address") ? this.$t("menus.zkpsh.care.cardfour.address") : null,
              button1:this.$te("menus.zkpsh.care.crdfour.button1") ? this.$t("menus.zkpsh.care.crdfour.button1") : null,
              button2:this.$te("menus.zkpsh.care.cardfour.button2") ? this.$t("menus.zkpsh.care.cardfour.button2") : null ,
            },
            {
              id: 4,
              icon: "fa-phone-volume",
              title: this.$te("menus.zkpsh.care.cardsix.title") ? this.$t("menus.zkpsh.care.cardsix.title") : null,
              fullName:this.$te("menus.zkpsh.care.cardsix.fullName") ? this.$t("menus.zkpsh.care.cardsix.fullName") : null,
              position:this.$te("menus.zkpsh.care.cardsix.position") ? this.$t("menus.zkpsh.care.cardsix.position") : null,
              email:this.$te("menus.zkpsh.care.cardsix.email") ? this.$t("menus.zkpsh.care.cardsix.email") : null,
              tel1:this.$te("menus.zkpsh.care.cardsix.tel1") ? this.$t("menus.zkpsh.care.cardsix.tel1") : null,
              address:this.$te("menus.zkpsh.care.cardsix.address") ? this.$t("menus.zkpsh.care.cardsix.address") : null,
              button1:this.$te("menus.zkpsh.care.crdsix.button1") ? this.$t("menus.zkpsh.care.crdsix.button1") : null,
              button2:this.$te("menus.zkpsh.care.cardsix.button2") ? this.$t("menus.zkpsh.care.cardsix.button2") : null ,
            }
        ],
        pthprishtine: [
            {
              id: 0,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthprishtine.care.cardleft.title") ? this.$t("menus.pthprishtine.care.cardleft.title") : null,
              tel1:this.$te("menus.pthprishtine.care.cardleft.tel1") ? this.$t("menus.pthprishtine.care.cardleft.tel1") : null
            },
            {
              id: 1,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthprishtine.care.cardright.title") ? this.$t("menus.pthprishtine.care.cardright.title") : null,
              tel1: this.$te("menus.pthprishtine.care.cardright.tel1") ? this.$t("menus.pthprishtine.care.cardright.tel1") : null
            },
            {
              id: 2,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthprishtine.care.cardthree.title") ? this.$t("menus.pthprishtine.care.cardthree.title") : null,
              fullName:this.$te("menus.pthprishtine.care.cardthree.fullName") ? this.$t("menus.pthprishtine.care.cardthree.fullName") : null,
              position:this.$te("menus.pthprishtine.care.cardthree.position") ? this.$t("menus.pthprishtine.care.cardthree.position") : null,
              email:this.$te("menus.pthprishtine.care.cardthree.email") ? this.$t("menus.pthprishtine.care.cardthree.email") : null,
              tel1:this.$te("menus.pthprishtine.care.cardthree.tel1") ? this.$t("menus.pthprishtine.care.cardthree.tel1") : null,
            },
            {
              id: 3,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthprishtine.care.cardfour.title") ? this.$t("menus.pthprishtine.care.cardfour.title") : null,
              fullName:this.$te("menus.pthprishtine.care.cardfour.fullName") ? this.$t("menus.pthprishtine.care.cardfour.fullName") : null,
              email:this.$te("menus.pthprishtine.care.cardfour.email") ? this.$t("menus.pthprishtine.care.cardfour.email") : null,
              tel1:this.$te("menus.pthprishtine.care.cardfour.tel1") ? this.$t("menus.pthprishtine.care.cardfour.tel1") : null
            },
             {
              id: 4,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthprishtine.care.cardfive.title") ? this.$t("menus.pthprishtine.care.cardfive.title") : null,
              fullName:this.$te("menus.pthprishtine.care.cardfive.fullName") ? this.$t("menus.pthprishtine.care.cardfive.fullName") : null,
              email:this.$te("menus.pthprishtine.care.cardfive.email") ? this.$t("menus.pthprishtine.care.cardfive.email") : null,
              tel1:this.$te("menus.pthprishtine.care.cardfive.tel1") ? this.$t("menus.pthprishtine.care.cardfive.tel1") : null
            }
        ],
        pthprizren: [
            {
              id: 0,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthprizren.care.cardleft.title") ? this.$t("menus.pthprizren.care.cardleft.title") : null,
              tel1:this.$te("menus.pthprizren.care.cardleft.tel1") ? this.$t("menus.pthprizren.care.cardleft.tel1") : null
            },
            {
              id: 1,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthprizren.care.cardright.title") ? this.$t("menus.pthprizren.care.cardright.title") : null,
              tel1: this.$te("menus.pthprizren.care.cardright.tel1") ? this.$t("menus.pthprizren.care.cardright.tel1") : null
            },
            {
              id: 2,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthprizren.care.cardthree.title") ? this.$t("menus.pthprizren.care.cardthree.title") : null,
              fullName:this.$te("menus.pthprizren.care.cardthree.fullName") ? this.$t("menus.pthprizren.care.cardthree.fullName") : null,
              position:this.$te("menus.pthprizren.care.cardthree.position") ? this.$t("menus.pthprizren.care.cardthree.position") : null,
              email:this.$te("menus.pthprizren.care.cardthree.email") ? this.$t("menus.pthprizren.care.cardthree.email") : null,
              tel1:this.$te("menus.pthprizren.care.cardthree.tel1") ? this.$t("menus.pthprizren.care.cardthree.tel1") : null,
            },
            {
              id: 3,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthprizren.care.cardfour.title") ? this.$t("menus.pthprizren.care.cardfour.title") : null,
              fullName:this.$te("menus.pthprizren.care.cardfour.fullName") ? this.$t("menus.pthprizren.care.cardfour.fullName") : null,
              email:this.$te("menus.pthprizren.care.cardfour.email") ? this.$t("menus.pthprizren.care.cardfour.email") : null,
              tel1:this.$te("menus.pthprizren.care.cardfour.tel1") ? this.$t("menus.pthprizren.care.cardfour.tel1") : null,
            },
            {
              id: 4,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthprizren.care.cardfive.title") ? this.$t("menus.pthprizren.care.cardfive.title") : null,
              fullName:this.$te("menus.pthprizren.care.cardfive.fullName") ? this.$t("menus.pthprizren.care.cardfive.fullName") : null,
              email:this.$te("menus.pthprizren.care.cardfive.email") ? this.$t("menus.pthprizren.care.cardfive.email") : null,
              tel1:this.$te("menus.pthprizren.care.cardfive.tel1") ? this.$t("menus.pthprizren.care.cardfive.tel1") : null,
            }
        ],
        pthferizaj: [
            {
              id: 0,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthferizaj.care.cardleft.title") ? this.$t("menus.pthferizaj.care.cardleft.title") : null,
              tel1:this.$te("menus.pthferizaj.care.cardleft.tel1") ? this.$t("menus.pthferizaj.care.cardleft.tel1") : null
            },
            {
              id: 1,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthferizaj.care.cardright.title") ? this.$t("menus.pthferizaj.care.cardright.title") : null,
              tel1: this.$te("menus.pthferizaj.care.cardright.tel1") ? this.$t("menus.pthferizaj.care.cardright.tel1") : null
            },
            {
              id: 2,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthferizaj.care.cardthree.title") ? this.$t("menus.pthferizaj.care.cardthree.title") : null,
              fullName:this.$te("menus.pthferizaj.care.cardthree.fullName") ? this.$t("menus.pthferizaj.care.cardthree.fullName") : null,
              position:this.$te("menus.pthferizaj.care.cardthree.position") ? this.$t("menus.pthferizaj.care.cardthree.position") : null,
              email:this.$te("menus.pthferizaj.care.cardthree.email") ? this.$t("menus.pthferizaj.care.cardthree.email") : null,
              tel1:this.$te("menus.pthferizaj.care.cardthree.tel1") ? this.$t("menus.pthferizaj.care.cardthree.tel1") : null
            },
            {
              id: 3,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthferizaj.care.cardfour.title") ? this.$t("menus.pthferizaj.care.cardfour.title") : null,
              fullName:this.$te("menus.pthferizaj.care.cardfour.fullName") ? this.$t("menus.pthferizaj.care.cardfour.fullName") : null,
              email:this.$te("menus.pthferizaj.care.cardfour.email") ? this.$t("menus.pthferizaj.care.cardfour.email") : null,
              tel1:this.$te("menus.pthferizaj.care.cardfour.tel1") ? this.$t("menus.pthferizaj.care.cardfour.tel1") : null
            },
            {
              id: 4,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthferizaj.care.cardfive.title") ? this.$t("menus.pthferizaj.care.cardfive.title") : null,
              fullName:this.$te("menus.pthferizaj.care.cardfive.fullName") ? this.$t("menus.pthferizaj.care.cardfive.fullName") : null,
              position:this.$te("menus.pthferizaj.care.cardfive.position") ? this.$t("menus.pthferizaj.care.cardfive.position") : null,
              email:this.$te("menus.pthferizaj.care.cardfive.email") ? this.$t("menus.pthferizaj.care.cardfive.email") : null,
              tel1:this.$te("menus.pthferizaj.care.cardfive.tel1") ? this.$t("menus.pthferizaj.care.cardfive.tel1") : null
            }
        ],
        pthpeje: [
            {
              id: 0,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthpeje.care.cardleft.title") ? this.$t("menus.pthpeje.care.cardleft.title") : null,
              tel1:this.$te("menus.pthpeje.care.cardleft.tel1") ? this.$t("menus.pthpeje.care.cardleft.tel1") : null
            },
            {
              id: 1,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthpeje.care.cardright.title") ? this.$t("menus.pthpeje.care.cardright.title") : null,
              tel1: this.$te("menus.pthpeje.care.cardright.tel1") ? this.$t("menus.pthpeje.care.cardright.tel1") : null
            },
            {
              id: 2,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthpeje.care.cardthree.title") ? this.$t("menus.pthpeje.care.cardthree.title") : null,
              fullName:this.$te("menus.pthpeje.care.cardthree.fullName") ? this.$t("menus.pthpeje.care.cardthree.fullName") : null,
              position:this.$te("menus.pthpeje.care.cardthree.position") ? this.$t("menus.pthpeje.care.cardthree.position") : null,
              email:this.$te("menus.pthpeje.care.cardthree.email") ? this.$t("menus.pthpeje.care.cardthree.email") : null,
              tel1:this.$te("menus.pthpeje.care.cardthree.tel1") ? this.$t("menus.pthpeje.care.cardthree.tel1") : null,
            },
            {
              id: 3,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthpeje.care.cardfour.title") ? this.$t("menus.pthpeje.care.cardfour.title") : null,
              fullName:this.$te("menus.pthpeje.care.cardfour.fullName") ? this.$t("menus.pthpeje.care.cardfour.fullName") : null,
              position:this.$te("menus.pthpeje.care.cardfour.position") ? this.$t("menus.pthpeje.care.cardfour.position") : null,
              email:this.$te("menus.pthpeje.care.cardfour.email") ? this.$t("menus.pthpeje.care.cardfour.email") : null,
              tel1:this.$te("menus.pthpeje.care.cardfour.tel1") ? this.$t("menus.pthpeje.care.cardfour.tel1") : null,
            },
             {
              id: 4,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthpeje.care.cardfive.title") ? this.$t("menus.pthpeje.care.cardfive.title") : null,
              fullName:this.$te("menus.pthpeje.care.cardfive.fullName") ? this.$t("menus.pthpeje.care.cardfive.fullName") : null,
              position:this.$te("menus.pthpeje.care.cardfive.position") ? this.$t("menus.pthpeje.care.cardfive.position") : null,
              email:this.$te("menus.pthpeje.care.cardfive.email") ? this.$t("menus.pthpeje.care.cardfive.email") : null,
              tel1:this.$te("menus.pthpeje.care.cardfive.tel1") ? this.$t("menus.pthpeje.care.cardfive.tel1") : null,
            }
        ],
        pthmitrovice: [
            {
              id: 0,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthmitrovice.care.cardleft.title") ? this.$t("menus.pthmitrovice.care.cardleft.title") : null,
              tel1:this.$te("menus.pthmitrovice.care.cardleft.tel1") ? this.$t("menus.pthmitrovice.care.cardleft.tel1") : null
            },
            {
              id: 1,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthmitrovice.care.cardright.title") ? this.$t("menus.pthmitrovice.care.cardright.title") : null,
              tel1: this.$te("menus.pthmitrovice.care.cardright.tel1") ? this.$t("menus.pthmitrovice.care.cardright.tel1") : null
            },
            {
              id: 2,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthmitrovice.care.cardthree.title") ? this.$t("menus.pthmitrovice.care.cardthree.title") : null,
              fullName:this.$te("menus.pthmitrovice.care.cardthree.fullName") ? this.$t("menus.pthmitrovice.care.cardthree.fullName") : null,
              position:this.$te("menus.pthmitrovice.care.cardthree.position") ? this.$t("menus.pthmitrovice.care.cardthree.position") : null,
              email:this.$te("menus.pthmitrovice.care.cardthree.email") ? this.$t("menus.pthmitrovice.care.cardthree.email") : null,
              tel1:this.$te("menus.pthmitrovice.care.cardthree.tel1") ? this.$t("menus.pthmitrovice.care.cardthree.tel1") : null,
            },
            {
              id: 3,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthmitrovice.care.cardfour.title") ? this.$t("menus.pthmitrovice.care.cardfour.title") : null,
              fullName:this.$te("menus.pthmitrovice.care.cardfour.fullName") ? this.$t("menus.pthmitrovice.care.cardfour.fullName") : null,
              email:this.$te("menus.pthmitrovice.care.cardfour.email") ? this.$t("menus.pthmitrovice.care.cardfour.email") : null,
              tel1:this.$te("menus.pthmitrovice.care.cardfour.tel1") ? this.$t("menus.pthmitrovice.care.cardfour.tel1") : null,
            },
            {
              id: 4,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthmitrovice.care.cardfive.title") ? this.$t("menus.pthmitrovice.care.cardfive.title") : null,
              fullName:this.$te("menus.pthmitrovice.care.cardfive.fullName") ? this.$t("menus.pthmitrovice.care.cardfive.fullName") : null,
              position:this.$te("menus.pthmitrovice.care.cardfive.position") ? this.$t("menus.pthmitrovice.care.cardfive.position") : null,
              email:this.$te("menus.pthmitrovice.care.cardfive.email") ? this.$t("menus.pthmitrovice.care.cardfive.email") : null,
              tel1:this.$te("menus.pthmitrovice.care.cardfive.tel1") ? this.$t("menus.pthmitrovice.care.cardfive.tel1") : null,
            }
        ],
        pthgjilan: [
            {
              id: 0,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthgjilan.care.cardleft.title") ? this.$t("menus.pthgjilan.care.cardleft.title") : null,
              tel1:this.$te("menus.pthgjilan.care.cardleft.tel1") ? this.$t("menus.pthgjilan.care.cardleft.tel1") : null
            },
            {
              id: 1,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthgjilan.care.cardright.title") ? this.$t("menus.pthgjilan.care.cardright.title") : null,
              tel1: this.$te("menus.pthgjilan.care.cardright.tel1") ? this.$t("menus.pthgjilan.care.cardright.tel1") : null
            },
            {
              id: 2,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthgjilan.care.cardthree.title") ? this.$t("menus.pthgjilan.care.cardthree.title") : null,
              fullName:this.$te("menus.pthgjilan.care.cardthree.fullName") ? this.$t("menus.pthgjilan.care.cardthree.fullName") : null,
              email:this.$te("menus.pthgjilan.care.cardthree.email") ? this.$t("menus.pthgjilan.care.cardthree.email") : null,
              tel1:this.$te("menus.pthgjilan.care.cardthree.tel1") ? this.$t("menus.pthgjilan.care.cardthree.tel1") : null
            },
            {
              id: 3,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthgjilan.care.cardfour.title") ? this.$t("menus.pthgjilan.care.cardfour.title") : null,
              fullName:this.$te("menus.pthgjilan.care.cardfour.fullName") ? this.$t("menus.pthgjilan.care.cardfour.fullName") : null,
              email:this.$te("menus.pthgjilan.care.cardfour.email") ? this.$t("menus.pthgjilan.care.cardfour.email") : null,
              tel1:this.$te("menus.pthgjilan.care.cardfour.tel1") ? this.$t("menus.pthgjilan.care.cardfour.tel1") : null,
            },
             {
              id: 4,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthgjilan.care.cardfive.title") ? this.$t("menus.pthgjilan.care.cardfive.title") : null,
              fullName:this.$te("menus.pthgjilan.care.cardfive.fullName") ? this.$t("menus.pthgjilan.care.cardfive.fullName") : null,
              email:this.$te("menus.pthgjilan.care.cardfive.email") ? this.$t("menus.pthgjilan.care.cardfive.email") : null,
              tel1:this.$te("menus.pthgjilan.care.cardfive.tel1") ? this.$t("menus.pthgjilan.care.cardfive.tel1") : null,
            }
        ],
        pthgjakove: [
            {
              id: 0,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthgjakove.care.cardleft.title") ? this.$t("menus.pthgjakove.care.cardleft.title") : null,
              tel1:this.$te("menus.pthgjakove.care.cardleft.tel1") ? this.$t("menus.pthgjakove.care.cardleft.tel1") : null
            },
            {
              id: 1,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthgjakove.care.cardright.title") ? this.$t("menus.pthgjakove.care.cardright.title") : null,
              tel1: this.$te("menus.pthgjakove.care.cardright.tel1") ? this.$t("menus.pthgjakove.care.cardright.tel1") : null
            },
            {
              id: 2,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthgjakove.care.cardthree.title") ? this.$t("menus.pthgjakove.care.cardthree.title") : null,
              fullName:this.$te("menus.pthgjakove.care.cardthree.fullName") ? this.$t("menus.pthgjakove.care.cardthree.fullName") : null,
              email:this.$te("menus.pthgjakove.care.cardthree.email") ? this.$t("menus.pthgjakove.care.cardthree.email") : null,
              tel1:this.$te("menus.pthgjakove.care.cardthree.tel1") ? this.$t("menus.pthgjakove.care.cardthree.tel1") : null,
            },
            {
              id: 3,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthgjakove.care.cardfour.title") ? this.$t("menus.pthgjakove.care.cardfour.title") : null,
              fullName:this.$te("menus.pthgjakove.care.cardfour.fullName") ? this.$t("menus.pthgjakove.care.cardfour.fullName") : null,
              email:this.$te("menus.pthgjakove.care.cardfour.email") ? this.$t("menus.pthgjakove.care.cardfour.email") : null,
              tel1:this.$te("menus.pthgjakove.care.cardfour.tel1") ? this.$t("menus.pthgjakove.care.cardfour.tel1") : null,
            },
             {
              id: 4,
              icon: "fa-phone-volume",
              title: this.$te("menus.pthgjakove.care.cardfive.title") ? this.$t("menus.pthgjakove.care.cardfive.title") : null,
              fullName:this.$te("menus.pthgjakove.care.cardfive.fullName") ? this.$t("menus.pthgjakove.care.cardfive.fullName") : null,
              email:this.$te("menus.pthgjakove.care.cardfive.email") ? this.$t("menus.pthgjakove.care.cardfive.email") : null,
              tel1:this.$te("menus.pthgjakove.care.cardfive.tel1") ? this.$t("menus.pthgjakove.care.cardfive.tel1") : null,
            }
        ]
      }

      return allData[sub] || allData.default
    }
  }
}
</script>

<style scoped>
.container {
  padding-top: 48px;
  padding-bottom: 48px;
  margin-bottom: 0 !important;
}
</style>
